import { observer } from "mobx-react-lite";

import { UnitField } from "@/components/doc/right-sidebar/active-node-style/fields/UnitField";
import { ConvertField } from "@/components/doc/right-sidebar/active-node-style/number/ConvertField";
import { NumberValueField } from "@/components/doc/right-sidebar/active-node-style/number/NumberValueField";
import { Sidebar } from "@/components/sidebar";

import type { NumberNodeModel } from "@/models/nodes/NumberNodeModel";

type Props = {
  node: NumberNodeModel;
};

export const NumberStyle = observer(function NumberStyle({ node }: Props) {
  return (
    <div data-panel="number_style" className="px-[5px]">
      <div className="bg-document-bg shadow-block dark:shadow-block-inverted rounded-6 flex-1 min-w-0 mb-2">
        <NumberValueField node={node} />
        {node.unitNode && (
          <>
            <Sidebar.Delimiter className="m-0" />
            <UnitField node={node} />
            <ConvertField node={node} />
          </>
        )}
      </div>
    </div>
  );
});
